import Header from '@/components/layout/Header.vue'
import Footer from '@/components/layout/Footer.vue'

export default {
    name: "main_layout",
    
    components: {
        Header,
        Footer
    }
}
